import { render, staticRenderFns } from "./drawerNew.vue?vue&type=template&id=347740f9&scoped=true&lang=pug"
import script from "./drawerNew.vue?vue&type=script&lang=js"
export * from "./drawerNew.vue?vue&type=script&lang=js"
import style0 from "./drawerNew.vue?vue&type=style&index=0&id=347740f9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347740f9",
  null
  
)

export default component.exports